
// Copyright 2002-2013, University of Colorado

/**
 * Gradient base type for LinearGradient and RadialGradient. Will not function on its own
 *
 * @author Jonathan Olson <olsonsjc@gmail.com>
 */

define( 'SCENERY/util/Gradient',['require','SCENERY/util/Color','SCENERY/scenery','DOT/Vector2'],function( require ) {
  'use strict';
  
  require( 'SCENERY/util/Color' );
  var scenery = require( 'SCENERY/scenery' );
  
  var Vector2 = require( 'DOT/Vector2' );

  // TODO: add the ability to specify the color-stops inline. possibly [ [0,color1], [0.5,color2], [1,color3] ]
  scenery.Gradient = function Gradient( canvasGradient ) {
    sceneryAssert && sceneryAssert( this.constructor.name !== 'Gradient', 'Please create a LinearGradient or RadialGradient. Do not directly use the supertype Gradient.' );
    
    this.stops = [];
    this.lastStopRatio = 0;
    
    this.canvasGradient = canvasGradient;
    
    this.transformMatrix = null;
  };
  var Gradient = scenery.Gradient;
  
  Gradient.prototype = {
    constructor: Gradient,
    
    /**
     * @param {Number} ratio        Monotonically increasing value in the range of 0 to 1
     * @param {Color|String} color  Color for the stop, either a scenery.Color or CSS color string
     */
    addColorStop: function( ratio, color ) {
      // TODO: invalidate the gradient?
      if ( this.lastStopRatio > ratio ) {
        // fail out, since browser quirks go crazy for this case
        throw new Error( 'Color stops not specified in the order of increasing ratios' );
      } else {
        this.lastStopRatio = ratio;
      }
      
      // make sure we have a scenery.Color now
      if ( typeof color === 'string' ) {
        color = new scenery.Color( color );
      }
      
      this.stops.push( {
        ratio: ratio,
        color: color
      } );
      
      // construct the Canvas gradient as we go
      this.canvasGradient.addColorStop( ratio, color.toCSS() );
      return this;
    },
    
    setTransformMatrix: function( transformMatrix ) {
      // TODO: invalidate the gradient?
      if ( this.transformMatrix !== transformMatrix ) {
        this.transformMatrix = transformMatrix;
      }
      return this;
    },
    
    getCanvasStyle: function() {
      return this.canvasGradient;
    }
  };
  
  return Gradient;
} );
